import React from 'react'
import { DynamicText as DynamicTextType } from '../../types/brand'
import { insertHandlebarsTemplate } from '../../utils/insertHandlebarsTemplate'
import useHandlebarsContext from '../../hooks/useHandlebarsContext'

interface Props {
  text: DynamicTextType
}

const DynamicText: React.FC<Props> = ({ text }) => {
  const handlebarsContext = useHandlebarsContext()
  return (
    <span>
      {insertHandlebarsTemplate(`{{${text.textVariable}}}`, handlebarsContext)}
    </span>
  )
}

export default DynamicText
